import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const DetectToken = 'detectToken'
const CompanyId = 'companyId'
const Icon = 'icon'
const CompanyName = 'companyName'
const DbIndex = 'dbIndex'
const IsPrintOther = 'isPrintOther'

export function getIsPrintOther() {
  return Cookies.get(IsPrintOther)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getDetectToken() {
  return Cookies.get(DetectToken)
}

export function getCompanyId() {
  return Cookies.get(CompanyId)
}

export function getIcon() {
  return Cookies.get(Icon)
}

export function getCompanyName() {
  return Cookies.get(CompanyName)
}

export function getDbIndex() {
  return Cookies.get(DbIndex)
}

export function setIsPrintOther(isPrintOther) {
  return Cookies.set(IsPrintOther, isPrintOther)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function setDetectToken(detectToken) {
  return Cookies.set(DetectToken, detectToken)
}

export function setCompanyId(companyId) {
  return Cookies.set(CompanyId, companyId)
}

export function setIcon(icon) {
  return Cookies.set(Icon, icon)
}

export function setCompanyName(companyName) {
  return Cookies.set(CompanyName, companyName)
}

export function setDbIndex(dbIndex) {
  return Cookies.set(DbIndex, dbIndex)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js